// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"CommModal_backdrop__aDK9C","content":"CommModal_content__17xGa","modal":"CommModal_modal__tmBST","slide-down":"CommModal_slide-down__3itHX"};